export const schemaMetadataFileName = "schema.gadget.ts";
